import { useMemo } from "react";

import If from "~/core/ui/If";

import PrimaryButton from "~/components/Buttons/PrimaryButton";

import { faArrowTurnDownLeft } from "@fortawesome/pro-regular-svg-icons";

import { NEXT_MEETING_COMMAND_ID } from "../../constants/common";
import { useGlobalCommandbarStore } from "../../store";

export default function PrimaryCTA() {
  const activeCommandbarItemId = useGlobalCommandbarStore(
    st => st.activeCommandbarItemId,
  );
  const commandbarSearchItems = useGlobalCommandbarStore(
    st => st.commandbarSearchItems,
  );
  const commandbarCommandItems = useGlobalCommandbarStore(
    st => st.commandbarCommandItems,
  );
  const commandbarPageItems = useGlobalCommandbarStore(
    st => st.commandbarPageItems,
  );

  const activeItem = useMemo(() => {
    const allItems = [
      ...commandbarCommandItems,
      ...commandbarSearchItems,
      ...commandbarPageItems,
    ];
    const item = allItems.find(item => item.id === activeCommandbarItemId);

    return item;
  }, [
    activeCommandbarItemId,
    commandbarCommandItems,
    commandbarPageItems,
    commandbarSearchItems,
  ]);

  if (!activeItem && activeCommandbarItemId !== NEXT_MEETING_COMMAND_ID)
    return null;

  return (
    <PrimaryButton shortcutIcons={[faArrowTurnDownLeft]}>
      <If
        condition={activeCommandbarItemId === NEXT_MEETING_COMMAND_ID}
        fallback={activeItem?.ctaLabel}
      >
        <span>Join</span>
      </If>
    </PrimaryButton>
  );
}
